//export const BaseUrl = 'http://localhost:5000/api/v2';
//export const media = "http://localhost:5000/";
//export const mealUrl="http://localhost:5000/MealDetails/"
export const BaseUrl = 'https://api.saba-restaurant-eg.com/api/v2';
export const media = "https://api.saba-restaurant-eg.com/";
export const mealUrl="https://saba-restaurant-eg.com/MealDetails/"